import { Tooltip as TooltipPrimitive } from "radix-ui";
import { forwardRef } from "react";

export const TooltipProvider = TooltipPrimitive.Provider;

const InternalTooltip = TooltipPrimitive.Root;

const InternalTooltipTrigger = TooltipPrimitive.Trigger;

const InternalTooltipContent = forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    className="z-50 max-w-80 overflow-hidden text-wrap rounded-md border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-900 shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
    ref={ref}
    sideOffset={sideOffset}
    {...props}
  />
));
InternalTooltipContent.displayName = TooltipPrimitive.Content.displayName;

export function Tooltip({
  title,
  children,
}: {
  readonly title: string | null;
  readonly children: React.ReactNode;
}) {
  return (
    <InternalTooltip>
      <InternalTooltipTrigger asChild className="text-start">
        {children}
      </InternalTooltipTrigger>
      {title !== null && (
        <InternalTooltipContent>{title}</InternalTooltipContent>
      )}
    </InternalTooltip>
  );
}
